module.exports = __webpack_public_path__ + "img/3.0d85bc7f.svg";